import ApiService from '../../services/api.service'
import { Notify } from 'quasar'

export const apiGoogle = {
  state: {
    userEmail: null,
    isAuthorizedForForms: false,
    authorizedEmail: null
  },
  mutations: {
    setUserEmail(state, email) {
      state.userEmail = email
    },
    setAuthorizedForForms(state, isAuthorized) {
      state.isAuthorizedForForms = isAuthorized
    },
    setAuthorizedEmail(state, email) {
      state.authorizedEmail = email
    },
    resetAuth(state) {
      state.userEmail = null
      state.isAuthorizedForForms = false
      state.authorizedEmail = null
    }
  },
  actions: {
    /**
     * Vérifie le statut d'authentification Google et les autorisations.
     */
    async checkAuthStatus({ commit }) {
      try {
        const response = await ApiService.getRequest('/auth-token/check')
        if (response.data.isAuthenticated) {
          commit('setUserEmail', response.data.email)
          commit('setAuthorizedForForms', response.data.isAuthorizedForForms)
          commit('setAuthorizedEmail', response.data.authorizedEmail)
          return true
        } else {
          commit('resetAuth')
          return false
        }
      } catch (error) {
        console.error(
          "Erreur lors de la vérification de l'authentification :",
          error
        )
        commit('resetAuth')

        Notify.create({
          message:
            "Erreur lors de la vérification de l'authentification Google",
          color: 'red'
        })

        return false
      }
    },

    /**
     * Déconnecte l'utilisateur du compte Google.
     */
    async logout({ commit }) {
      try {
        const response = await ApiService.postRequest('/google-api/logout')
        commit('resetAuth')

        Notify.create({
          message: 'Déconnexion de Google réussie',
          color: 'green'
        })

        return true
      } catch (error) {
        console.error('Erreur lors de la déconnexion :', error)

        Notify.create({
          message: 'Erreur lors de la déconnexion du compte Google',
          color: 'red'
        })

        return false
      }
    },

    /**
     * Authentifie l'utilisateur avec Google pour les formulaires.
     */
    async authGoogle({ commit }, redirectPath = '/google-forms') {
      try {
        // Enregistrer la page de redirection
        localStorage.setItem('googleAuthRedirect', redirectPath)

        const response = await ApiService.postRequest('/auth/google')
        if (response.data && response.data.redirect_url) {
          window.location.href = response.data.redirect_url
          return true
        } else {
          throw new Error('URL de redirection non trouvée dans la réponse')
        }
      } catch (error) {
        console.error("Erreur lors de l'authentification avec Google :", error)

        Notify.create({
          message: 'Erreur lors de la connexion à Google',
          color: 'red'
        })

        return false
      }
    },

    /**
     * Authentifie l'utilisateur avec Google Drive pour les documents.
     */
    async authGoogleDrive({ commit }, returnPath = '/stagiaires') {
      try {
        // Enregistrer le chemin de retour
        localStorage.setItem('googleDriveCallback', returnPath)

        const response = await ApiService.postRequest('/drive/auth/google')
        if (response.data && response.data.redirect_url) {
          window.location.href = response.data.redirect_url
          return true
        } else {
          throw new Error('URL de redirection non trouvée dans la réponse')
        }
      } catch (error) {
        console.error(
          "Erreur lors de l'authentification avec Google Drive :",
          error
        )

        Notify.create({
          message: 'Erreur de connexion à Google Drive',
          color: 'red'
        })

        return false
      }
    }
  },
  getters: {
    getUserEmail(state) {
      return state.userEmail
    },
    isAuthorizedForForms(state) {
      return state.isAuthorizedForForms
    },
    getAuthorizedEmail(state) {
      return state.authorizedEmail
    }
  }
}
